"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _index = _interopRequireDefault(require("./index.styled"));
var linkItemColors = _interopRequireWildcard(require("./linkItem.themes"));
var _default = exports.default = (0, _styledComponentThemes.withThemes)(_index.default.LinkItem, linkItemColors);